// extracted by mini-css-extract-plugin
module.exports = {"root":"src-reactapp-Settings-TypographPluginModal---root"};